import React, { useContext, useEffect, useMemo } from 'react';
import { useGoogleMap } from '@react-google-maps/api';
import addCurrentLocation from 'google-maps-current-location';
import PropTypes from 'prop-types';
import Markers from './Markers';
import { DealersListContext } from '../DealersListContext';
import parseCoordinatesToNumbers from '../../utils/googleMap/parseCoordinatesToNumbers';
import fitMapToMarkersBounds from '../../utils/googleMap/fitMapToMarkersBounds';

const MapBounds = ({ isMapLocked }) => {
  const map = useGoogleMap();
  const { dealersList, selectedDealer, hoveredDealer } = useContext(DealersListContext);

  const dealerMarkers = useMemo(
    () =>
      dealersList?.map(dealer => ({
        id: dealer?.id,
        coordinates: parseCoordinatesToNumbers(dealer?.location?.coordinates),
        isSelected: selectedDealer?.id === dealer?.id || hoveredDealer?.id === dealer?.id,
      })),
    [dealersList, selectedDealer, hoveredDealer],
  );

  useEffect(() => {
    fitMapToMarkersBounds(map, dealerMarkers);
  }, []);

  useEffect(() => {
    if (!selectedDealer && !hoveredDealer) {
      fitMapToMarkersBounds(map, dealerMarkers);
    }
  }, [dealerMarkers, map, selectedDealer, hoveredDealer]);

  useEffect(() => {
    if (isMapLocked) {
      const { controls } = map;
      const controlArray = controls[window.google?.maps?.ControlPosition?.RIGHT_BOTTOM];
      if (controlArray) {
        controlArray.clear();
      }
    } else {
      addCurrentLocation(map, {
        markerStyle: {
          scale: 10,
        },
      });
    }
  }, [map, isMapLocked]);

  return <Markers markers={dealerMarkers} />;
};

MapBounds.propTypes = {
  isMapLocked: PropTypes.bool.isRequired,
};

export default MapBounds;
